// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./toast.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./login.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./lobby.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./nalavo.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: "roboto";
}

#root {
  height: 100%;
}

.block {
  padding: 3vw 5vw;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.top-block {
  padding: 3vw 5vw;
  position: sticky;
  top: 0;
}


.block-active {
  box-shadow: 0 0 10px #888;
  background: #0066cc;
  color: white;
  margin-bottom: 20px;
  /* margin-top: 20px; */
}

.block-secondary {
  /* box-shadow: 0 0 10px #888; */
  background: #eee;
  color: black;
  margin-bottom: 20px;
  /* margin-top: 20px; */
}

.label {
  display: block;
  margin-bottom: 5px;
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: 500;
  color: #808080;
}

.txtbox {
  padding: 10px 0 5px 0;
  font-size: 1.25rem;
  /* border-radius: 5px; */
  /* border: 2px solid #808080; */
  border: none;
  border-bottom: 1px solid gray;
  /* width: 100%; */
  box-sizing: border-box;
  caret-color: #0066cc;
}

.txtbox:focus {
  /* transition: 0.05s; */
  outline: none;
  border-bottom: 2px solid #0066cc;
  /* border-width: 2px; */
  border-color: #0066cc;
}

.txtbox::placeholder {
  opacity: 0.6;
}

/* .txtbox.invalid {
  border-bottom-color: red;
}

.txtbox.valid {
  border-bottom-color: green;
} */

.btn {
  background-color: #0066cc;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  padding: 10px;
  cursor: pointer;
  font-weight: 700;
}

.btn:disabled {
  background-color: #ccc;
  color: #777;
  cursor: unset;
  border: none;
}

.btn-wide {
  width: 100%;
}

.btn-white {
  background-color: white;
  color: #0066cc;
}

.btn-red {
  background-color: #882211;
  color: white;
}

.btn-green {
  background-color: #009000;
  color: white;
}

.btn-outline {
  background: none;
  color: #0066cc;
  border: 1px solid #0066cc;
}

.btn-outline-white {
  background: none;
  color: white;
  border: 1px solid white;
}

.btn-text {
  background: none;
  color: #0066cc;
}
`, "",{"version":3,"sources":["webpack://./src/style/style.css"],"names":[],"mappings":"AAKA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;AACR;;;AAGA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;GAMG;;AAEH;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["@import 'toast.css';\n@import 'login.css';\n@import 'lobby.css';\n@import 'nalavo.css';\n\nbody, html {\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  font-family: \"roboto\";\n}\n\n#root {\n  height: 100%;\n}\n\n.block {\n  padding: 3vw 5vw;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.top-block {\n  padding: 3vw 5vw;\n  position: sticky;\n  top: 0;\n}\n\n\n.block-active {\n  box-shadow: 0 0 10px #888;\n  background: #0066cc;\n  color: white;\n  margin-bottom: 20px;\n  /* margin-top: 20px; */\n}\n\n.block-secondary {\n  /* box-shadow: 0 0 10px #888; */\n  background: #eee;\n  color: black;\n  margin-bottom: 20px;\n  /* margin-top: 20px; */\n}\n\n.label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 1rem;\n  text-transform: uppercase;\n  font-weight: 500;\n  color: #808080;\n}\n\n.txtbox {\n  padding: 10px 0 5px 0;\n  font-size: 1.25rem;\n  /* border-radius: 5px; */\n  /* border: 2px solid #808080; */\n  border: none;\n  border-bottom: 1px solid gray;\n  /* width: 100%; */\n  box-sizing: border-box;\n  caret-color: #0066cc;\n}\n\n.txtbox:focus {\n  /* transition: 0.05s; */\n  outline: none;\n  border-bottom: 2px solid #0066cc;\n  /* border-width: 2px; */\n  border-color: #0066cc;\n}\n\n.txtbox::placeholder {\n  opacity: 0.6;\n}\n\n/* .txtbox.invalid {\n  border-bottom-color: red;\n}\n\n.txtbox.valid {\n  border-bottom-color: green;\n} */\n\n.btn {\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 1rem;\n  padding: 10px;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.btn:disabled {\n  background-color: #ccc;\n  color: #777;\n  cursor: unset;\n  border: none;\n}\n\n.btn-wide {\n  width: 100%;\n}\n\n.btn-white {\n  background-color: white;\n  color: #0066cc;\n}\n\n.btn-red {\n  background-color: #882211;\n  color: white;\n}\n\n.btn-green {\n  background-color: #009000;\n  color: white;\n}\n\n.btn-outline {\n  background: none;\n  color: #0066cc;\n  border: 1px solid #0066cc;\n}\n\n.btn-outline-white {\n  background: none;\n  color: white;\n  border: 1px solid white;\n}\n\n.btn-text {\n  background: none;\n  color: #0066cc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
